import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    addressFieldContainer: {
        width: "100%",
        textAlign: "left",
    },
    titleContainer: {
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
    },
    formSubtitle: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "20px",
        color: theme.palette.secondary.dark,
        margin: "0",
    },
    formTitle: {
        fontFamily: "Open Sans !important",
        fontWeight: "600 !important",
        color: theme.palette.secondary.dark,
        fontSize: "32px !important",
    },
    fieldsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),
        justifyContent: "center",
        alignItems: "center",
    },
    select: {
        textAlign: "left",
    },
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    cancelButton: {
        marginRight: "20px !important",
        "&.MuiButtonBase-root": {
            height: "36px !important",
            fontFamily: "Open Sans",
            marginBottom: "30px",
        },
    },
    submitButton: {
        "&.MuiButtonBase-root": {
            background: theme.palette.info.light,
            color: "white",
            height: "36px !important",
            fontFamily: "Open Sans",
            marginBottom: "30px",
            "&:hover": {
                background: theme.palette.info.light,
            },
        },
    },
    listContainer: {
        "&.MuiList-root": {
            paddingTop: 0,
        },
        width: "100%",
    },
    listItem: {
        display: "flex",
        marginBottom: "10px",
    },
    listText: {
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: 600,
            color: theme.palette.secondary.dark,
        },
    },
    separator: {
        paddingBottom: "20px",
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
        width: "100%",
    },
    separatorNoPadding: {
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
        width: "100%",
    },
    checkbox: {
        "&.MuiCheckbox-root": {
            "&.Mui-checked": {
                color: "#292F37",
            },
        },
    },
    checkboxLabelErrors: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        "&.MuiFormControlLabel-root .MuiTypography-root": {
            color: "rgba(0, 0, 0, 0.6)",
            fontSize: "12px",
        },
    },
    checkboxLabel: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        "&.MuiFormControlLabel-root .MuiTypography-root": {
            color: "rgba(0, 0, 0, 0.6)",
            fontSize: "12px",
        },
    },
    useCorporateAdminCheckbox: {
        display: "flex",
        alignItems: "center",
    },
    error: {
        color: `${theme.palette.error.main} !important`,
    },
    naicsCodeLink: {
        display: "flex",
        gap: theme.spacing(1),
        color: theme.palette.info.main,
        fontSize: "12px",
        fontFamily: "Open Sans",
        marginTop: theme.spacing(2.5),
        alignItems: "center",
    },
    listItemContainer: {
        display: "flex",
        gap: theme.spacing(2),
    },
    listContainerTitle: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "16px",
        color: theme.palette.secondary.dark,
    },
    listContainerEmail: {
        fontFamily: "Open Sans",
        fontWeight: 400,
        fontSize: "16px",
        color: theme.palette.secondary.dark,
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Open Sans",
            paddingBottom: "5px",
        },
    },
    noMillManagersWrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    addMillManagerActions: {
        display: "flex",
        alignItems: "center",
        width: "100%",
    },
    divider: {
        width: "100%",
        fontFamily: "Open Sans",
        fontSize: "12px",
        "&::before": {
            width: "0% !important",
        },
    },
    billingAddressContainer: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    billingAddressContainerFields: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),
        width: "100%",
    },
}));
